var e = Object.defineProperty;
var s = (i, t, r) => t in i ? e(i, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : i[t] = r;
var n = (i, t, r) => (s(i, typeof t != "symbol" ? t + "" : t, r), r);
const a = class a {
  constructor(t, r) {
    this.dateString = t, this.hourString = r;
  }
  static fromDate(t) {
    return new a(
      t.format(this.formatDateString),
      t.hour().toString()
    );
  }
  static fromDateAndHourRepresentation(t, r) {
    return new a(
      t.format(this.formatDateString),
      r.from.toString()
    );
  }
};
n(a, "formatDateString", "YYYY-MM-DD");
let o = a;
export {
  o as SlotDayAndHourKey
};
